import {
  PermPlacementDetailsGetters,
  PermPlacementDetailsActions,
  PermPlacementDetailsMutations
} from './perm-placement-details.keys';
import { permPlacementDetailsService } from './perm-placement-details.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import i18n from '@/i18n';
import router from '@/router';

export const getDefaultState = () => {
  return {
    isLoading: true,
    isLoadingAttachments: false,
    currentPermPlacement: {},
    currentPermPlacementAttachments: [],
    currentPermPlacementHistories: [],
    permPlacementHistoriesSortOrder: {},
    permPlacementAttachmentsSortOrder: {},
    permPlacementValidationErrors: {}
  };
};
export const permPlacementDetailsStore = {
  state: getDefaultState(),
  getters: {
    [PermPlacementDetailsGetters.CurrentPermPlacement]: state => {
      return state.currentPermPlacement;
    },
    [PermPlacementDetailsGetters.SelectedRecordHistory]: state => permPlacementId => {
      return state.currentPermPlacementHistories.filter(
        historyRecord => historyRecord.id === permPlacementId
      )[0];
    },
    [PermPlacementDetailsGetters.CurrentPermPlacementHistories]: state =>
      state.currentPermPlacementHistories,
    [PermPlacementDetailsGetters.CurrentPermPlacementAttachments]: state =>
      state.currentPermPlacementAttachments,
    [PermPlacementDetailsGetters.GetPermPlacementDetailsValidationErrors]: state =>
      state.permPlacementValidationErrors
  },
  actions: {
    [PermPlacementDetailsActions.RetrievePermPlacement]: (
      { commit, dispatch },
      referenceNumber
    ) => {
      return permPlacementDetailsService
        .retrievePermPlacement(referenceNumber)
        .then(perm => {
          commit(PermPlacementDetailsMutations.RetrievePermPlacementSuccess, perm);
          dispatch(PermPlacementDetailsActions.RetrievePermPlacementHistories, referenceNumber);
          dispatch(PermPlacementDetailsActions.RetrievePermPlacementAttachments, referenceNumber);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('permPlacement.details.errors.retrievePermPlacement')
          });
          commit(PermPlacementDetailsMutations.SetLoading, false);
        });
    },
    [PermPlacementDetailsActions.RetrievePermPlacementHistories]: (
      { state, commit, dispatch },
      referenceNumber
    ) => {
      return permPlacementDetailsService
        .retrievePermPlacementHistories(referenceNumber, state.permPlacementHistoriesSortOrder)
        .then(histories => {
          commit(PermPlacementDetailsMutations.RetrievePermPlacementHistoriesSuccess, histories);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [PermPlacementDetailsActions.RetrievePermPlacementAttachments]: (
      { state, commit, dispatch },
      referenceNumber
    ) => {
      return permPlacementDetailsService
        .retrievePermPlacementAttachments(referenceNumber, state.permPlacementAttachmentsSortOrder)
        .then(attachments => {
          commit(
            PermPlacementDetailsMutations.RetrievePermPlacementAttachmentsSuccess,
            attachments
          );
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [PermPlacementDetailsActions.DoPermPlacementAction]: ({ dispatch, commit }, params) => {
      let { permPlacement, action } = params;
      permPlacementDetailsService
        .doPermPlacementAction(permPlacement, action)
        .then(status => {
          if (status.message === 'success') {
            dispatch(PermPlacementDetailsActions.RetrievePermPlacement, status.data);
            if (Object.keys(status.info).length > 0) {
              dispatch(TolMessagesActions.SetMessages, status.info);
            }
            router.replace(`/perm-placements/${status.data}`).catch(err => {
              if (err.name !== 'NavigationDuplicated') throw err;
            });
          } else {
            dispatch(
              PermPlacementDetailsActions.UpdatePermPlacementValidationErrors,
              status.errors
            );
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
          commit(PermPlacementDetailsMutations.SetLoading, false);
        });
    },
    [PermPlacementDetailsActions.ResetPermPlacementState]: ({ commit }) => {
      commit(PermPlacementDetailsMutations.ResetPermPlacementState);
    },
    [PermPlacementDetailsActions.UpdatePermPlacementValidationErrors]: (
      { commit },
      errors = {}
    ) => {
      commit(PermPlacementDetailsMutations.SetPermPlacementValidationErrors, errors);
    }
  },
  mutations: {
    [PermPlacementDetailsMutations.RetrievePermPlacementSuccess]: (state, perm) => {
      state.currentPermPlacement = perm;
    },
    [PermPlacementDetailsMutations.RetrievePermPlacementHistoriesSuccess]: (state, histories) => {
      state.currentPermPlacementHistories = histories;
    },
    [PermPlacementDetailsMutations.RetrievePermPlacementAttachmentsSuccess]: (
      state,
      attachments
    ) => {
      state.currentPermPlacementAttachments = attachments;
    },
    [PermPlacementDetailsMutations.SetLoading]: (state, loading) => (state.isLoading = loading),
    [PermPlacementDetailsMutations.ResetPermPlacementState]: state => {
      Object.assign(state, getDefaultState());
    },
    [PermPlacementDetailsMutations.SetPermPlacementValidationErrors](state, errors) {
      state.permPlacementValidationErrors = errors;
    }
  }
};
